import { Component, Input, OnChanges } from '@angular/core';
import { FilterTypeDateQueryModel } from '../../models/filter-type-date-query.model';
import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';
import { DateQueryModel } from '../../../Forms/models/date-query.model';

@Component({
    selector: 'agpr-filter-date-query',
    templateUrl: './filter-date-query.component.html',
    styleUrls: ['./filter-date-query.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: FilterDateQueryComponent
        }
    ],
    standalone: false
})
export class FilterDateQueryComponent extends AbstractFilterTypeComponent implements OnChanges {
    @Input() declare filter: FilterTypeDateQueryModel;

    value: DateQueryModel;

    ngOnChanges(): void {
        this.refresh();
    }

    /**
     * Refreshes the current value from the filter
     */
    refresh(): void {
        this.value = this.filter.getCurrentValue();
    }

    /**
     * Updates the current value of the filter
     */
    handleChange(): void {
        this.filter.setCurrentValue(this.value);
    }
}
